import Customer from "../Models/Customer";
import Order from "../Models/Order";
import ItemCategory from "../Models/ItemCategory";
import PageModel from "../Models/ViewModels/PageModel";
import MakeRequest from "../Utilities/MakeRequest";
import OrderResponse from "../Models/Response/OrderResponse";
import DibsPaymentResponse from "../Models/Response/DibsPaymentResponse";
import CreatePayment from "../Models/CreatePayment";
import UpdateOrder from "../Models/UpdateOrder/UpdateOrder";
import OrderViewModel from "../Models/ViewModels/OrderViewModel";

export function fetchOrdersList(searchValue: string, sortValue: string, sortAscending: boolean, currentPage: number, pageSize: number, status: number, isSearchByStoreEnabled: boolean): Promise<PageModel<OrderViewModel>> {
	return new Promise<PageModel<OrderViewModel>>((resolve, reject) => {
		const statusSegment = status === null ? "" : `${status}`;
		new MakeRequest(`/api/Orders/search?searchValue=${searchValue}&SortValue=${sortValue}&SortAscending=${sortAscending}&Page=${currentPage}&Size=${pageSize}&Status=${statusSegment}&IsSearchByStoreEnabled=${isSearchByStoreEnabled}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function fetchOrderOverviewModal(id: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/Orders/Overview?id=${id}`)
			.send()
			.then(resolve, reject);
	});
}

export function fetchOrderStatusTrackLogModal(id: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/Orders/OrderStatusTrackLog?id=${id}`)
			.send()
			.then(resolve, reject);
	});
}
export function fetchCustomerQuestionsModal(id: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/Orders/CustomerQuestions?id=${id}`)
			.send()
			.then(resolve, reject);
	})
}

export function fetchFirstCustomerQuestionsModal(id: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/Orders/CustomerFirstQuestions?id=${id}`)
			.send()
			.then(resolve, reject)
	});
}

export function fetchOrderUpdateModal(id: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/Orders/Update?id=${id}`)
			.send()
			.then(resolve, reject);
	});
}

export function GetOrder(id: string): Promise<Order> {
	return new Promise<Order>((resolve, reject) => {
		new MakeRequest(`/api/Orders/Get?id=${id}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function fetchOrderReceiptPDFHTMLString(id: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/api/Orders/GetOrderReceiptPDFHTMLString?id=${id}`)
			.send()
			.then(resolve, reject);
	});
}

export function fetchNextOrderStatus(code: string, command: string): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		new MakeRequest(`/api/Orders/MoveNextStatus?code=${code}&command=${command}`)
			.send()
			.then(resolve, reject);
	});
}

export function checkOrderTagCode(code: string): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		new MakeRequest(`/api/Orders/CheckTagCode?code=${code}`)
			.send()
			.then(resolve, reject);
	});
}

export function validateOrder(order: Order): Promise<void> {
	const headers = {};
	headers["Content-type"] = "application/json";
	return new Promise<void>((resolve, reject) => {
		new MakeRequest(`/api/Orders/ValidateOrder`, "Post", headers)
			.send(JSON.stringify(order))
			.then(resolve, reject);
	});
}

export function searchCustomers(value: string, searchByName: boolean): Promise<Array<Customer>> {
	return new Promise<Array<Customer>>((resolve, reject) => {
		new MakeRequest(`/api/orders/SearchCustomers?value=${value}&searchByName=${searchByName}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function getAllItems(): Promise<Array<ItemCategory>> {
	return new Promise<Array<ItemCategory>>((resolve, reject) => {
		new MakeRequest('/api/orders/getAllItems')
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function createOrder(order: Order): Promise<OrderResponse> {
	return new Promise<OrderResponse>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest('/api/Orders/Create', "Post", headers)
			.send(JSON.stringify(order))
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function updateOrder(order: UpdateOrder): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest('/api/Orders/Update', "Put", headers)
			.send(JSON.stringify(order))
			.then(resolve, reject);
	});
}

export function updateOrderCustomer(order: UpdateOrder): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest('/api/Orders/UpdateCustomer', "Put", headers)
			.send(JSON.stringify(order))
			.then(resolve, reject);
	});
}

export function createPayment(payment: CreatePayment): Promise<DibsPaymentResponse> {
	return new Promise<DibsPaymentResponse>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest('/api/Orders/CreatePayment', "Post", headers)
			.send(JSON.stringify(payment))
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}
